import {CustomRouter} from "@utils/router";
import {getUrlLogout} from "@core/decorators/catch";

export interface ErrorPageMessagePayload {
    mensagemPrincipal: string;
    mensagemComplementar?: string;
    url?: string;
}

function normalizarMensagem(mensagem: string): string {
    return (mensagem || '').trim().replace(/\s+/g, ' ');
}

function normalizarPayload(mensagem: string | ErrorPageMessagePayload): ErrorPageMessagePayload {
    if (typeof mensagem === 'string') {
        return {
            mensagemPrincipal: mensagem
        };
    }

    const mensagemPrincipal = normalizarMensagem(mensagem.mensagemPrincipal);
    const mensagemComplementar = normalizarMensagem(mensagem.mensagemComplementar || '');

    return {
        mensagemPrincipal,
        mensagemComplementar: mensagemComplementar || undefined,
        url: mensagem.url
    };
}

export const ServerError = {
    showErrorPage: (message: string | ErrorPageMessagePayload) => {
        const url = getUrlLogout();
        const payload = normalizarPayload(message);

        CustomRouter.navigate('erro', {
            ...payload,
            url: payload.url || url
        });
    }
}
